import { render, staticRenderFns } from "./dialogSetup.vue?vue&type=template&id=39981a3e&"
import script from "./dialogSetup.vue?vue&type=script&lang=js&"
export * from "./dialogSetup.vue?vue&type=script&lang=js&"
import style0 from "./dialogSetup.vue?vue&type=style&index=0&id=39981a3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports